import {
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  YAxis,
  Bar,
  Line,
  LabelList,
  Tooltip,
  BarChart,
  Legend,
} from "recharts";
import { numberFormatter } from "../../utils";
import divider from "../../assets/divider-logo.3699f955.svg";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import { Tooltip as TooltipInfo, Whisper } from "rsuite";

interface DateRange {
  baseline: number | null;
  current: number | null;
}
interface Props {
  chartData: Array<T>;
  heading: any;
  dateRange?: DateRange;
}

interface T {
  quarter: string;
  actual: number;
  forecastedSpend: number;
  spendNeededForNextTier: number;
  spendShift: number;
  targetGrowthSpend: number;
}

const NiaImprovements = (props: Props) => {
  let chartData: any = props?.chartData;
  let newData: any = [];

  if (chartData?.graph3?.length > 0) {
    let totalNia = 0;
    let totalSpend = 0;
    let totalNIAImprovement = 0;
    let vendorNames = "";
    chartData?.graph3?.map((item: any, k: any) => {
      if (item?.NIA) {
        totalNia = totalNia + item.NIA;
        totalSpend = totalSpend + item.Spend;
        totalNIAImprovement =
          totalNIAImprovement +
          (item.niaImprovementOptional
            ? item.niaImprovementOptional
            : item.NIAImprovement);
      }
    });

    let niaImprove = 0;
	let ly_niamprove=0
    chartData?.graph3?.map((item: any, k: any) => {
      if (item.NIAImprovement > 0) {
        niaImprove = niaImprove + (item.Spend * item.NIAImprovement) / 100;
        vendorNames =
          vendorNames +
          (vendorNames == ""
            ? item.master_vendor_name
            : ", " + item.master_vendor_name);
      }
	  if(item?.capturedIncrementalBenefit_LY>0){
		ly_niamprove+=item?.capturedIncrementalBenefit_LY
	  }
    });

    newData.push({
      date: "2024",
      NIA: totalNia,
      NIAImprovement: ly_niamprove,
      NIAImprovementPercentage: totalNIAImprovement,
      NIAImprovementDummy: ly_niamprove===0?0:totalNia * (ly_niamprove>niaImprove?0.45:0.4),
      mastorVendorNames: vendorNames,
    });

    newData.push({
      date: "2025",
      NIA: totalNia,
      NIAImprovement: niaImprove,
      NIAImprovementPercentage: totalNIAImprovement,
      NIAImprovementDummy: niaImprove == 0 ? 0 : totalNia * 0.45, //for giving specific height for the bar
      mastorVendorNames: vendorNames,
    });
  }

  let incrementalNIAEstimate: any;

  if (chartData?.graph2?.length > 0) {
    let lastValueIndex = 0;
    chartData?.graph2?.map((item: any, index: any) => {
      if (item.monthlyRev != 0) {
        lastValueIndex = index;
      }
    });

    incrementalNIAEstimate =
      chartData?.graph2[lastValueIndex].incrementalNIAEstimate;
  }

  let heading = props?.heading;

  const renderCustomLegend = (props: any) => {
    const { payload } = props;
    return (
      <div style={{ width: "26.5vw" }}>
        <ul className="graphLegend" style={{ width: "27vw" }}>
          {payload.map((entry: any, index: any) => (
            <li
              key={`item-${index}`}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: 4,
                color: "black",
                fontSize: "1.8vh",
              }}
            >
              {entry.value === "NIAImprovementDummy" ? (
                <img
                  src={divider}
                  alt="divder"
                  style={{
                    marginLeft: "0.5vw",
                    marginRight: "0.5vw",
                  }}
                />
              ) : (
                <></>
              )}
              <span
                style={{
                  backgroundColor: entry.color,
                  width: "0.5vh",
                  height: "2vh",
                  display: "inline-block",
                  marginRight: 5,
                  position: "relative",
                }}
              />
              {entry.value === "NIAImprovementDummy"
                ? "Incremental Benefit Captured"
                : "NIA"}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const renderCustomizedLabel2 = (props: any) => {
    const { x, y, width, height, value, index } = props;

    const offset = 10;
    return (
      <>
        {index == 1 && newData[0].NIA == 0 && newData[1].NIA == 0 ? (
          <text
            x={x - x / 4.5}
            y={y - y / 2.5}
            fill="black"
            textAnchor="middle"
            className="textSmall"
          >
            No NIA Contract
          </text>
        ) : (
          <text
            x={x + width / 2}
            y={y + height / 2}
            fill="white"
            textAnchor="middle"
            className="textSmall !text-[0.7vw]"
          >
            {newData[index].NIA > 0
              ? numberFormatter(newData[index].NIA, 1, "$")
              : ""}
          </text>
        )}
      </>
    );
  };
  const CustomLegend = () => (
    <div
      style={{
        display: "flex",
        gap: "2rem",
        alignItems: "center",
        color: "black",
        fontSize: "0.8rem",
      }}
    >
      <span>
        <span
          style={{
            display: "inline-block",
            width: 10,
            height: 18,
            background: "gray",
            marginRight: 8,
            verticalAlign: "middle",
          }}
        />
        NIA
      </span>
      <span>
        <span
          style={{
            display: "inline-block",
            width: 10,
            height: 18,
            background: "#62b5e5",
            marginRight: 8,
            verticalAlign: "middle",
          }}
        />
        Incremenatal Benefits Capture
      </span>
    </div>
  );

  const CustomizedTick = (data: any) => {
    const { x, y, payload, index } = data;
    const labelText =
      index === 0
        ? props?.dateRange?.baseline || 2024
        : props?.dateRange?.current || 2025;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
          {labelText}
        </text>
      </g>
    );
  };

  return (
    <div className={`w-full graphBox h-[100%]`}>
      {/* <div className="bg-[#ffff] graphBorder flex justify-between">
				<p className="text-center graphTitle pl-[1vh]">
					{" "}
					<span>5. </span>
					{heading}
				</p>
				<p className="flex justify-end px-[2vh] font-semibold text-[1.8vh] text-[#40a108] mt-[0]">
					<span className="flex justify-end">
						{newData[0]?.NIAImprovementPercentage > 0
							? `${numberFormatter(
									newData[0]?.NIAImprovementPercentage,
									1
							  )}% (${
									newData[0]?.mastorVendorNames ==
									"BRIDGEPORT FITTINGS, INC."
										? "BRIDGEPORT"
										: newData[0]?.mastorVendorNames
							  }) Base Improvement`
							: "No Base Rebate Improvement"}
					</span>
				</p>
			</div> */}
      <div className="headSpace">
        <span className="headContent w-[50%] !text-[1vw]"> {heading}</span>
        <p className="flex justify-end items-center px-[2vh] font-semibold textNormal mt-[0] text-[#40a108]">
          <span className="flex justify-end gap-x-[.5vh]">
            <span className="mb-[.5vh]">
              {newData[0]?.NIAImprovementPercentage > 0
                ? `${numberFormatter(
                    newData[0]?.NIAImprovementPercentage,
                    1,
                  )}% Base Improvement`
                : "No Base Rebate Improvement"}
            </span>
            <Whisper
              placement="left"
              speaker={
                <TooltipInfo>
                  <div>
                    {newData[0]?.mastorVendorNames ==
                    "BRIDGEPORT FITTINGS, INC."
                      ? "BRIDGEPORT"
                      : newData[0]?.mastorVendorNames}
                  </div>
                </TooltipInfo>
              }
            >
              <InfoOutlineIcon className="!ml-[3px] mb-[.5vh] text-black" />
            </Whisper>
          </span>
        </p>
      </div>
      <div className="h-full">
        <ResponsiveContainer width="100%" height="65%" className="bg-[#ffff] ">
          <BarChart
            data={newData}
            layout="horizontal"
            margin={{
              top: 40,
              right: 40,
              left: 40,
            }}
          >
            <XAxis
              className="graph-label-small "
              stroke="black"
              type="category"
              dataKey="date"
              tick={<CustomizedTick />}
            />
            <YAxis hide type="number" />
            {["NIA", "NIAImprovementDummy"].map((item: any, ind: number) => {
              return (
                <Bar
                  key={item}
                  dataKey={item}
                  stackId="a"
                  name={
                    ind === 0
                      ? props?.dateRange?.baseline || 2024
                      : props?.dateRange?.current || 2025
                  }
                  fill={ind == 0 ? "gray" : "#62b5e5"}
                  barSize={50}
                >
                  <LabelList
                    content={
                      item == "NIAImprovementDummy"
                        ? ($) => (
                            <RenderCustomizedLabel
                              payload={$}
                              newData={newData}
                              incrementalNIAEstimate={incrementalNIAEstimate}
                            />
                          )
                        : renderCustomizedLabel2
                    }
                    // {
                    //   item == "NIAImprovementDummy"
                    //     ? renderCustomizedLabel
                    //     : renderCustomizedLabel2
                    // }
                  />
                </Bar>
              );
            })}
          </BarChart>
        </ResponsiveContainer>
        <div className="contentFooter !justify-end">
          <CustomLegend></CustomLegend>
        </div>
      </div>
    </div>
  );
};

const RenderCustomizedLabel = (props: any) => {
  const { x, y, width, height, value, index } = props.payload;
  const { newData, incrementalNIAEstimate } = props;
  const offset = 10;
  return newData[index].NIAImprovement > 0 ? (
    <g>
      <text
        x={x + width / 2}
        y={y + height / 2}
        fill="white"
        textAnchor="middle"
        className="graph-label !text-[0.7vw]"
      >
        {newData[index].NIAImprovement > 0
          ? numberFormatter(newData[index].NIAImprovement, 1, "$")
          : ""}
      </text>

      <text
        x="24.8vw"
        y="8vh"
        fill="black"
        textAnchor="middle"
        className="graph-label valueCaptureGraphLabel"
      >
        Incremental
      </text>
      <text
        x="25.55vw"
        y="9.8vh"
        fill="black"
        textAnchor="middle"
        className="graph-label valueCaptureGraphLabel"
      >
        Benefit Captured
      </text>
      <text
        x="24.2vw"
        y="11.5vh"
        fill="black"
        textAnchor="middle"
        className="graph-label valueCaptureGraphLabel"
      >
        to Date:
      </text>
      <text
        x="26.5vw"
        y="11.5vh"
        fill="black"
        textAnchor="middle"
        className="graph-label valueCaptureGraphLabel"
        // fontWeight={600}
        style={{ fontWeight: "600" }}
      >
        {numberFormatter(incrementalNIAEstimate, 0, "$")}
      </text>
    </g>
  ) : (
    <></>
  );
};

export default NiaImprovements;
